module.exports = __webpack_public_path__ + "static/media/6.20.62d67a56.png";